export default __webpack_public_path__ + "static/media/06.46146c50.png";